import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import FeedbackWidget from "./FeedbackWidget";
import { store } from "./store";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root was not found");

createRoot(root).render(
  <StrictMode>
    <Provider store={store}>
      <App />
      <FeedbackWidget />
    </Provider>
  </StrictMode>,
);
